import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ESearchResultsActionType } from './types';

export const changeSearchResultsUrl = actionGenerator<ESearchResultsActionType.UrlChanged, string>(
  ESearchResultsActionType.UrlChanged,
);
